'use es6';

export const ALERT_TYPES = {
  info: 'alert-info private-alert--info',
  warning: 'alert-warning private-alert--warning',
  success: 'alert-success private-alert--success',
  danger: 'alert-danger private-alert--danger',
  tip: 'private-alert--tip'
};
export const ALERT_USES = {
  default: '',
  inline: 'private-alert--inline'
};